import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconDirective } from '@ui/components/icon';

@Component({
  selector: 'app-alert',
  imports: [IconDirective],
  templateUrl: './alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {}
